<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
      :savoynet="imovel.savoynet"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">Informações do imóvel</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs2>
        <v-container fluid class="py-2">
          <v-layout row wrap>
            <v-flex xs12 v-if="canEditInfo">
              <v-btn flat @click.stop="onSubmit" :disabled="isFormInvalid">
                <span class="subtitulo">Salvar</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <form v-on:submit.prevent="onSubmit">
      <v-layout row wrap class="pt-5">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
          <v-container fluid>
            <v-layout row wrap class="mt-3 readonly-form" :class="{ 'readonly-form--blocked': !canEditInfo }">
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  v-model="form.fields.apelido"
                  label="Nome do imóvel"
                  v-validate="'required'"
                  name="apelido"
                  data-vv-as="nome do imóvel"
                  :error-messages="errors.has('apelido') ? errors.first('apelido') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-bind:items="proprietarios"
                  v-model="form.fields.proprietarioSelect"
                  label="Dono do imóvel"
                ></v-select>
                <transition name="slide-x-transition" v-if="form.fields.proprietarioSelect === 'Preencher manualmente'">
                  <v-text-field
                    autocomplete="off"
                    v-model="form.fields.proprietario"
                    label="Nome do proprietário"
                  >
                  </v-text-field>
                </transition>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-bind:items="tipos"
                  v-model="form.fields.tipoSelect"
                  label="Tipo do imóvel"
                ></v-select>
                <transition name="slide-x-transition" v-if="form.fields.tipoSelect === 'Preencher manualmente'">
                  <v-text-field
                    autocomplete="off"
                    v-model="form.fields.tipo"
                    label="Tipo do imóvel"
                  >
                  </v-text-field>
                </transition>
              </v-flex>
              <v-flex xs12>
                <div v-if="form.fields.savoynet.length > 0" class="mb-2">
                  <v-chip
                    v-for="(item, index) in form.fields.savoynet"
                    :key="`savoynet-${item}-${index}`"
                    :close="canEditInfo"
                    class="mr-2 mb-2"
                    @input="removeSavoyNet(index)"
                  >
                    {{ item }}
                  </v-chip>
                </div>
                <v-text-field
                  autocomplete="off"
                  v-model="savoynetInput"
                  label="SavoyNet"
                  hint="Use Enter, vírgula, ponto e vírgula ou nova linha."
                  persistent-hint
                  @keydown="onSavoyNetKeydown"
                  @input="onSavoyNetInput"
                  @blur="commitSavoyNetInput"
                  @paste="onSavoyNetPaste"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="text-xs-center mt-4">
              <v-flex xs12 sm6 class="acao-coluna">
                  <v-btn
                  v-if="canDeleteInfo"
                  outline
                  block
                  large
                  class="red red--text ma-0"
                  @click.native.stop="openDialogExcluir"
                >
                  Excluir
                </v-btn>
                <v-dialog v-model="dialogExcluir" max-width="520">
                  <v-card>
                    <v-card-title class="headline">Excluir imóvel?</v-card-title>
                    <v-card-text><strong>ATENÇÃO:</strong> O imóvel não poderá ser recuperado após a exclusão.</v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="green--text darken-1" flat="flat" @click.native="dialogExcluir = false">Cancelar</v-btn>
                      <v-btn class="green--text darken-1" flat="flat" @click.native="excluirImovel">Excluir</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-flex>
              <v-flex xs12 sm6 class="acao-coluna" v-if="canEditInfo">
                <v-btn
                  type="submit"
                  outline
                  block
                  large
                  class="secondary secondary--text ma-0"
                  :disabled="isFormInvalid"
                >
                  Salvar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </form>
    <v-btn dark fab fixed bottom right class="secondary" :to="({ name: 'ImoveisDetalhesFotos', params: { tipo: 'ilustrativa', id: $route.params.id } })" v-if="canViewFotos">
      <v-icon>photo_library</v-icon>
    </v-btn>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import { normalizeSavoyNetList, parseSavoyNetFromApi, splitSavoyNetValues } from '@/utils/savoynet'
  import HeadersDetalhesResumo from '../Headers/HeadersDetalhesResumo'

  export default {
    components: {
      HeadersDetalhesResumo
    },
    data () {
      return {
        dialogExcluir: false,
        savoynetInput: '',
        form: {
          fields: {
            apelido: '',
            proprietarioSelect: '',
            proprietario: '',
            tipoSelect: '',
            tipo: '',
            savoynet: []
          }
        }
      }
    },
    mounted () {
      this.$store.dispatch('imoveis/loadProprietarios')
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      canViewInfo () {
        return this.$hasGranularPermission('info', 'view')
      },
      canEditInfo () {
        return this.$hasGranularPermission('info', 'edit')
      },
      canDeleteInfo () {
        return this.$hasGranularPermission('info', 'delete')
      },
      canViewFotos () {
        return this.$hasGranularPermission('fotos', 'view')
      },
      imovelTipoSugestoes () {
        return _.uniq(
          _.compact(
            _.map(this.$store.getters['constants/imovelTipo'], this.getImovelTipoItemValue)
          )
        )
      },
      tipos () {
        const tipos = this.imovelTipoSugestoes.slice(0)
        tipos.unshift({ text: 'Preencher manualmente', value: 'Preencher manualmente' }, { divider: true })
        return tipos
      },
      proprietarios () {
        let proprietarios = this.$store.getters['imoveis/proprietarios'].slice(0)

        proprietarios.unshift({ text: 'Preencher manualmente', value: 'Preencher manualmente' }, { divider: true })

        return proprietarios
      },
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    watch: {
      imovel () {
        this.form.fields.apelido = this.imovel.apelido
        this.form.fields.proprietarioSelect = this.imovel.proprietario
        this.form.fields.proprietario = this.imovel.proprietario
        this.setTipoFromValue(this.imovel.tipo)
        this.form.fields.savoynet = parseSavoyNetFromApi(this.imovel.savoynet)
        this.savoynetInput = ''
      },
      'form.fields.proprietarioSelect' (value) {
        if (value === 'Preencher manualmente') {
          this.form.fields.proprietario = ''
        } else {
          this.form.fields.proprietario = value
        }
      },
      'form.fields.tipoSelect' (value, oldValue) {
        if (value === 'Preencher manualmente') {
          if (oldValue && oldValue !== 'Preencher manualmente') {
            this.form.fields.tipo = ''
          }
        } else {
          this.form.fields.tipo = value
        }
      }
    },
    methods: {
      getImovelTipoItemValue (item) {
        if (item && typeof item === 'object') {
          return (item.text || item.value || '').trim()
        }

        return String(item || '').trim()
      },
      normalizeTipo (value) {
        return String(value || '').trim().replace(/\s+/g, ' ')
      },
      setTipoFromValue (value) {
        const tipo = this.normalizeTipo(value)
        this.form.fields.tipo = tipo

        if (!tipo) {
          this.form.fields.tipoSelect = ''
          return
        }

        if (this.imovelTipoSugestoes.indexOf(tipo) !== -1) {
          this.form.fields.tipoSelect = tipo
          return
        }

        this.form.fields.tipoSelect = 'Preencher manualmente'
      },
      addSavoyNetValues (values) {
        if (!this.canEditInfo) return
        this.form.fields.savoynet = normalizeSavoyNetList(this.form.fields.savoynet.concat(values))
      },
      commitSavoyNetInput () {
        if (!this.canEditInfo) return
        if (!this.savoynetInput) {
          return
        }

        this.addSavoyNetValues(splitSavoyNetValues(this.savoynetInput))
        this.savoynetInput = ''
      },
      onSavoyNetInput (value) {
        if (!this.canEditInfo) return
        if (!/[,\n;]/.test(value)) {
          return
        }

        this.addSavoyNetValues(splitSavoyNetValues(value))
        this.savoynetInput = ''
      },
      onSavoyNetKeydown (event) {
        if (!this.canEditInfo) return
        if (event.key !== 'Enter' && event.key !== ',' && event.key !== ';') {
          return
        }

        event.preventDefault()
        this.commitSavoyNetInput()
      },
      onSavoyNetPaste (event) {
        if (!this.canEditInfo) return
        const clipboardData = event.clipboardData || window.clipboardData
        const pastedText = clipboardData ? clipboardData.getData('text') : ''

        if (!pastedText) {
          return
        }

        event.preventDefault()
        this.addSavoyNetValues(splitSavoyNetValues(pastedText))
        this.savoynetInput = ''
      },
      removeSavoyNet (index) {
        if (!this.canEditInfo) return
        this.form.fields.savoynet.splice(index, 1)
      },
      openDialogExcluir () {
        if (!this.canDeleteInfo) return
        this.dialogExcluir = true
      },
      excluirImovel () {
        if (!this.canDeleteInfo) return
        axios.delete(`${apiURL}/imoveis/${this.$route.params.id}`).then((response) => {
          this.$store.dispatch('utils/showSnackbar', {
            persistent: true,
            type: 'success',
            text: 'Imóvel excluído com sucesso.'
          })
          this.$store.dispatch('utils/hideLoading')
          this.$router.push({ name: 'ImoveisLista' })
        }, () => {
          this.$store.dispatch('utils/showSnackbar', {
            text: 'Servidor indisponível. Tente novamente mais tarde.'
          })
          this.$store.dispatch('utils/hideLoading')
        })
      },
      onSubmit () {
        if (!this.canEditInfo) return
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            this.commitSavoyNetInput()

            const payload = {
              apelido: this.form.fields.apelido,
              proprietario: this.form.fields.proprietario,
              tipo: this.normalizeTipo(this.form.fields.tipo),
              savoynet: normalizeSavoyNetList(this.form.fields.savoynet)
            }

            axios.patch(`${apiURL}/imoveis/${this.$route.params.id}`, payload).then((response) => {
              this.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } })
              this.$store.dispatch('utils/hideLoading')
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>

<style scoped>
@media (max-width: 599px) {
  .acao-coluna + .acao-coluna {
    margin-top: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// DetalhesInfo.vue?0ea929fe